module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-BdIt.5f8452b.woff";